<template>
    <!-- 分散式收房合约详情 -->
    <div id="workOrderDetail">
        <!-- 详情 -->
        <van-tabs v-model="active" class="tabs">
            <van-tab title="基本信息">
                <van-cell title="工单编号" :value="workOrderDetail.basicWorkOrderInfo.number||'-'" />
                <van-cell title="工单类型" :value="workOrderDetail.basicWorkOrderInfo.typeName||'-'" />
                <van-cell title="服务类型">
                    <template #default>
                       <span
              v-for="(item, index) in workOrderDetail.basicWorkOrderInfo
                .serviceTypes || []"
              :key="index"
              >{{ item.typeNameOne }}-{{ item.typeNameTwo
              }}{{
                index + 1 ==
                workOrderDetail.basicWorkOrderInfo.serviceTypes.length
                  ? ""
                  : " | "
              }}</span
            >
                    </template>
                </van-cell>
                <van-cell title="客户姓名" :value="(workOrderDetail.basicWorkOrderInfo.customerName||'-')+`（${workOrderRoleList[workOrderDetail.basicWorkOrderInfo.customerType -1]}）`" />
                <van-cell title="客户电话">
                    <!-- <template #default>
                        <div style="color:#fd7e2d;" @click="call">
                            <van-icon name="phone-o" style="vertical-align: middle;" />{{workOrderDetail.basicWorkOrderInfo.customerPhone||'-'}}
                        </div>
                    </template> -->
                     <template #right-icon>
                        <a  class="" :href="'tel:'+workOrderDetail.basicWorkOrderInfo.customerPhone">
                        <van-icon name="phone" class="search-phone" color="#fd7e2d"  />
                        </a>
                    
                    </template>
                </van-cell>
                <van-cell title="状态" :value="workOrderStatusList[workOrderDetail.basicWorkOrderInfo.status-1]||'-'" />
                <van-cell title="房源编码" :value="workOrderDetail.basicWorkOrderInfo.houseNumber" />
                <van-cell title="地址" :value="workOrderDetail.basicWorkOrderInfo.address||'-'" />
                <van-cell title="相关房间数" :value="workOrderDetail.basicWorkOrderInfo.rooms||'-'" />

                <van-cell title="描述" :value="workOrderDetail.basicWorkOrderInfo.description||'-'" />
                <van-cell title="派单时间" :value="workOrderDetail.basicWorkOrderInfo.pdTime||'-'" />
                <van-cell title="完成时间" :value="workOrderDetail.basicWorkOrderInfo.finishTime||'-'" />
                <van-cell title="处理时长" v-if="workOrderDetail.basicWorkOrderInfo.status != 1&&workOrderDetail.basicWorkOrderInfo.status != 6">
                    <template #default>
                        <p><span v-if="workOrderDetail.basicWorkOrderInfo.handleDays">{{workOrderDetail.basicWorkOrderInfo.handleDays}}天</span><span>{{workOrderDetail.basicWorkOrderInfo.handleHours}}</span>时</p>
                    </template>
                </van-cell>
                  <van-cell title="派单人" :value="workOrderDetail.basicWorkOrderInfo.dispatchName||'-'" />
                <van-cell title="负责人" :value="workOrderDetail.basicWorkOrderInfo.principal||'-'" />
                <van-cell title="协同人">
                    <template #title>
                        <span>协同人
                            <van-icon name="add-o" @click="addCooperation" style="vertical-align: middle;transform: translateY(-1px);" />
                        </span>
                    </template>
                    <template #default>
                        <span v-for="(item,index) in workOrderDetail.basicWorkOrderInfo.cooperations ||[]" :key="index"><span>{{item.cooperation}}</span>
                            <van-icon name="close" @click="deleteCooperation(item)" style="vertical-align: middle;transform: translateY(-1px);margin-right:5px;" />
                        </span>
                    </template>
                </van-cell>
                <van-cell title="创建人" :value="workOrderDetail.basicWorkOrderInfo.creator||'-'" />
                <van-cell title="创建时间" :value="workOrderDetail.basicWorkOrderInfo.createDate||'-'" />
                <div>
                    <div class="title van-cell">
                        <!-- <i class="iconfont iconbookmark"></i> -->
                        图片&ensp;
                    </div>
                    <div class="imgBody">
                        <div class="imgCard" v-for="(item,index) in workOrderDetail.basicWorkOrderInfo.images" :key="index">
                            <div class="img" @click="imgShow=true;imgIndex = index;images=workOrderDetail.basicWorkOrderInfo.images;">
                                <van-image width="3rem" height="3rem" :src="item" />
                            </div>
                        </div>
                    </div>
                </div>
            </van-tab>
            <van-tab title="工单日志" class="assets" style="margin-top:0.2rem">
                <van-steps direction="vertical" :active="0" active-color="#FD7E2D" active-icon="more" inactive-icon="checked">
                    <van-step v-for="item in workOrderDetail.workOrderLogList||[]" :key="item.id">
                        <!-- 开始 -->
                        <div>
                            <h4>{{workOrderLogList[item.status-1]}}</h4>
                            <p>{{item.content}}</p>
                            <p>{{item.remark}}</p>
                            <p>{{item.createDate}}</p>
                        </div>

                    </van-step>
                </van-steps>
            </van-tab>
            <van-tab title="完成情况">
                <van-cell title="内容" :value="workOrderDetail.workOrderResult.content||'-'" />
                <van-cell title="费用" :value="workOrderDetail.workOrderResult.fee||'-'" />
                <div>
                    <div class="title van-cell">
                        <!-- <i class="iconfont iconbookmark"></i> -->
                        完成前照片&ensp;
                    </div>
                    <div class="imgBody">
                        <div class="imgCard" v-for="(item,index) in workOrderDetail.workOrderResult.preImageList" :key="index">
                            <div class="img" @click="imgShow=true;imgIndex = index;images=workOrderDetail.workOrderResult.preImageList;">
                                <van-image width="3rem" height="3rem" :src="item" />
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="title van-cell">
                        <!-- <i class="iconfont iconbookmark"></i> -->
                        完成后照片&ensp;
                    </div>
                    <div class="imgBody">
                        <div class="imgCard" v-for="(item,index) in workOrderDetail.workOrderResult.imageList" :key="index">
                            <div class="img" @click="imgShow=true;imgIndex = index;images=workOrderDetail.workOrderResult.imageList;">
                                <van-image width="3rem" height="3rem" :src="item" />
                            </div>
                        </div>
                    </div>
                </div>
            </van-tab>
            <van-tab title="客户评价">
                <van-cell title="服务效率">
                    <template #default>
                        <van-rate v-model="workOrderDetail.customerReviews.serviceEfficiency" readonly allow-half void-color="#eee" />
                    </template>
                </van-cell>
                <van-cell title="服务态度">
                    <template #default>
                        <van-rate v-model="workOrderDetail.customerReviews.serviceAttitude" readonly allow-half void-color="#eee" />
                    </template>
                </van-cell>
                <van-cell title="服务质量">
                    <template #default>
                        <van-rate v-model="workOrderDetail.customerReviews.serviceQuality" readonly allow-half void-color="#eee" />
                    </template>
                </van-cell>
                <van-cell title="评价内容" :value="workOrderDetail.customerReviews.content||'-'" />
                <div>
                    <div class="title van-cell">
                        <!-- <i class="iconfont iconbookmark"></i> -->
                        图片&ensp;
                    </div>
                    <div class="imgBody">
                        <div class="imgCard" v-for="(item,index) in workOrderDetail.customerReviews.imageList||[]" :key="index">
                            <div class="img" @click="imgShow=true;imgIndex = index;images=workOrderDetail.customerReviews.imageList;">
                                <van-image width="3rem" height="3rem" :src="item" />
                            </div>
                        </div>
                    </div>
                </div>
            </van-tab>
            <div style="height:1.2rem;"></div>
        </van-tabs>
        <div class="btn">
            <van-button type="primary" v-if="(workOrderDetail.basicWorkOrderInfo.status>=2&&workOrderDetail.basicWorkOrderInfo.status<=4)&&$store.state.user.id==workOrderDetail.basicWorkOrderInfo.principalId" @click="workOrderZd">转单</van-button>
            <van-button type="primary" v-if="(workOrderDetail.basicWorkOrderInfo.status==2)&&$store.state.user.id==workOrderDetail.basicWorkOrderInfo.principalId" @click="workOrderJd">接单</van-button>
            <van-button type="primary" v-if="(workOrderDetail.basicWorkOrderInfo.status==3)&&$store.state.user.id==workOrderDetail.basicWorkOrderInfo.principalId" @click="workOrderStart">处理</van-button>
            <van-button type="primary" v-if="(workOrderDetail.basicWorkOrderInfo.status==4)&&$store.state.user.id==workOrderDetail.basicWorkOrderInfo.principalId" @click="workOrderFinish">完成</van-button>
            <van-button type="primary" @click="workOrderRemark">添加备注</van-button>
            <van-button type="primary" @click="goTo">导航</van-button>
        </div>
        <van-popup v-model="showCustomer" position="bottom" :style="{ height: '70%' }">
            <div class="search">
                <div class="searchInput">
                    <form action="/">
                        <van-search v-model="searchValueCustomer" shape="round" show-action placeholder="请输入内容搜索" @input="onSearchCustomer" @search="onSearchCustomer" @cancel="showCustomer = false" />
                    </form>
                </div>
                <div class="searchValue">
                    <van-search />
                    <van-checkbox-group v-model="customerQuery" :max="type=='xzr'?5:1">
                        <van-cell-group>
                            <van-cell v-for="(item, index) in customerSearchList" clickable :key="item.id" :title="`${item.name}（${item.type==1?'员工':'供应商'}）`" @click="toggle(index)">
                                <template #right-icon>
                                    <van-checkbox :name="item" ref="checkboxes" />
                                </template>
                            </van-cell>
                        </van-cell-group>
                    </van-checkbox-group>
                    <van-loading v-if="searchLoad" size="24" />
                    <div style="height:1.2rem"></div>
                </div>
                <div class="searchBtn">
                    <van-button type="default">已选择{{customerQuery.length||0}}人</van-button>
                    <van-button type="primary" @click="confirm">确认</van-button>
                </div>
            </div>
        </van-popup>
        <!-- 转单备注 -->
        <van-dialog v-model="zdShow" title="转单原因" show-cancel-button :before-close="zdRemarkSubmit">
            <van-form ref="zdForm">
                <van-field v-model="zdRemark" rows="3" autosize type="textarea" maxlength="100" placeholder="请输入转单原因" show-word-limit :rules="[{ required: true, message: '请输入转单原因' }]" />
            </van-form>
        </van-dialog>
        <!-- 完成 -->
        <van-dialog v-model="finishShow" title="完成工单" show-cancel-button :before-close="finishSubmit">
            <van-form ref="finishForm" input-align="right" class="dialogForm">
                <van-field required v-model="finishQuery.content" label="内容" rows="3" autosize type="textarea" maxlength="100" placeholder="请输入内容" :rules="[{ required: true, message: '请输入内容' }]" />
                <van-field type="number" v-model="finishQuery.fee" label="费用" placeholder="请输入费用" :rules="[{ validator: validNum0Decimal2, message: '费用必须大于等于0且最多保留两位小数' }]">
                    <template #extra>
                        <span style="font-size:0.32rem;padding-left:0.1rem">元</span>
                    </template>
                </van-field>
                <div class="field" v-if="!(workOrderDetail.basicWorkOrderInfo.type=='BJ'&&workOrderDetail.basicWorkOrderInfo.serviceTypes[0].typeNameOne=='退租保洁')">完成前照片</div>
                <div class="body body1" v-if="!(workOrderDetail.basicWorkOrderInfo.type=='BJ'&&workOrderDetail.basicWorkOrderInfo.serviceTypes[0].typeNameOne=='退租保洁')">
                    <van-uploader :before-read="beforeRead" :after-read="item => {preImageList.pop();preImageList.push({
            url: upload_qiniu_addr + item.file.key,
            isImage: true
          })}" v-model="preImageList" :max-count="10" />
                </div>
                <div class="field" :class="{'van-cell--required':(workOrderDetail.basicWorkOrderInfo.type=='BJ'||workOrderDetail.basicWorkOrderInfo.type=='WX')}">完成后照片</div>
                <div class="body body1">
                    <van-uploader :before-read="beforeRead" :after-read="item => {imageList.pop();imageList.push({
            url: upload_qiniu_addr + item.file.key,
            isImage: true
          });$refs.finishForm.resetValidation('imageList')}" v-model="imageList" :max-count="10" />
                </div>
                <div class="errorLeft" v-if="workOrderDetail.basicWorkOrderInfo.type=='BJ'||workOrderDetail.basicWorkOrderInfo.type=='WX'">
                    <van-field name="imageList" :rules="[{ validator:item=>{return imageList.length>0}, message: '请上传完成后照片' }]" />
                </div>
            </van-form>
        </van-dialog>
        <!-- 添加备注 -->
        <van-dialog v-model="remarkShow" title="添加备注" show-cancel-button :before-close="remarkSubmit">
            <van-form ref="remarkForm">
                <van-field required v-model="remarkQuery.remark" rows="3" autosize type="textarea" maxlength="100" placeholder="请输入备注" :rules="[{ required: true, message: '请输入备注' }]" />
            </van-form>
        </van-dialog>

        <!-- 图片预览 -->
        <van-image-preview v-model="imgShow" :startPosition="imgIndex" :images="images"></van-image-preview>
    </div>
</template>

<script>
import { mapState } from "vuex";
import {
    validPhone,
    validEmail,
    validIdNo,
    validNum0Decimal2,
    validNum100,
} from "@/utils/validate";
import * as dd from "dingtalk-jsapi"; //钉钉
import {
    requestWorkOrderDetail,
    requestWorkOrderJd,
    requestWorkOrderCl,
    requestWorkOrderSupplier,
    requestWorkOrderZd,
    requestWorkOrderRemark,
    requestWorkOrderFinish,
    requestWorkOrderCooperation,
    requestWorkOrderCooperationD,
    requestQiniuToken,
    requestDDConfig,
} from "@/api";
import { compress, compressAccurately } from "image-conversion";
import request from "@/utils/request";
import { mergeRowCol, accSub, formatDate, parseTime } from "@/utils/index";
export default {
    name: "workOrderDetail",
    data() {
        return {
            active: 0,
            workOrderDetail: {
                basicWorkOrderInfo: {},
                customerReviews: {},
                workOrderLogList: [],
                workOrderResult: {},
            },
            imgShow: false,
            imgIndex: 0,
            images: [],
            type: "", //区分当前操作（转单派单等）
            searchValueCustomer: "",
            searchLoad: false,
            showCustomer: false,
            customerQuery: [],
            customerSearchList: [],
            zdRemark: "",
            zdShow: false,
            //完成
            finishShow: false,
            finishQuery: {
                workOrderId: "",
                content: "",
                fee: "",
                preImageList: [],
                imageList: [],
            },
            preImageList: [],
            imageList: [],
            qiniuData: {},
            //添加备注
            remarkShow: false,
            remarkQuery: {
                id: "",
                remark: "",
            },
        };
    },
    computed: {
        ...mapState([
            "workOrderStatusList",
            "upload_qiniu_addr",
            "workOrderLogList",
            "workOrderRoleList"
        ]),
    },
    created() {
        this.getDetail();
        this.onSearchCustomer();
        this.getQiniuToken();
    },
    mounted() {
        this.getDDconfig();
    },
    methods: {
        getDetail() {
            const toast1 = this.$toast.loading({
                forbidClick: true,
                duration: 0,
                message: "加载中...",
            });
            requestWorkOrderDetail(this.$route.query.id)
                .then((res) => {
                    res.data.customerReviews = res.data.customerReviews || {};
                    res.data.workOrderResult = res.data.workOrderResult || {};
                    this.workOrderDetail = res.data;
                    this.loading = false;
                    toast1.clear();
                })
                .catch((err) => {
                    toast1.clear();
                });
        },
        //搜索客户
        onSearchCustomer() {
            this.searchLoad = true;
            requestWorkOrderSupplier({
                customerInfo: this.searchValueCustomer,
            }).then((res) => {
                this.searchLoad = false;
                this.customerSearchList = res.data || [];
            });
        },
        toggle(index) {
            this.$refs.checkboxes[index].toggle();
        },

        //添加协同人
        addCooperation() {
            this.type = "xzr";
            this.showCustomer = true;
        },
        //删除协同人
        deleteCooperation(item) {
            this.$dialog.confirm({
                title: "提示",
                message: "确认删除",
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                beforeClose: (action, done) => {
                    if (action === "confirm") {
                        requestWorkOrderCooperationD({
                            workOrderId: this.workOrderDetail.id,
                            cooperationId: item.cooperationId,
                        })
                            .then((res) => {
                                done();
                                this.$toast({
                                    type: "success",
                                    message: "删除成功!",
                                    forbidClick: true,
                                    onClose: () => {
                                        this.getDetail();
                                    },
                                });
                            })
                            .catch((err) => {
                                done(false);
                            });
                    } else {
                        done();
                    }
                },
            });
        },
        //转单
        workOrderZd() {
            this.type = "zd";
            this.showCustomer = true;
        },
        zdRemarkSubmit(action, done) {
            if (action === "confirm") {
                this.$refs.zdForm
                    .validate()
                    .then((valid) => {
                        let zdQuery = {
                            principal: this.customerQuery[0].name,
                            principalId: this.customerQuery[0].id,
                            workOrderId: this.$route.query.id,
                            remark: this.zdRemark,
                        };
                        requestWorkOrderZd(zdQuery)
                            .then((res) => {
                                this.$toast.success({
                                    message: "转单成功！",
                                    forbidClick: true,
                                    onClose: () => {
                                        this.showCustomer = false;
                                        this.zdRemark = "";
                                        this.$router.back();
                                        done();
                                    },
                                });
                            })
                            .catch((err) => {
                                done();
                            });
                    })
                    .catch((err) => {
                        done(false);
                    });
            } else {
                done();
            }
        },
        //接单
        workOrderJd() {
            this.$dialog.confirm({
                title: "提示",
                message: "确认接单",
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                beforeClose: (action, done) => {
                    if (action === "confirm") {
                        requestWorkOrderJd(this.workOrderDetail.id)
                            .then((res) => {
                                done();
                                this.$toast({
                                    type: "success",
                                    message: "接单成功!",
                                    forbidClick: true,
                                    onClose: () => {
                                        this.getDetail();
                                    },
                                });
                            })
                            .catch((err) => {
                                done(false);
                            });
                    } else {
                        done();
                    }
                },
            });
        },
        //处理
        workOrderStart() {
            this.$dialog.confirm({
                title: "提示",
                message: "确认处理",
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                beforeClose: (action, done) => {
                    if (action === "confirm") {
                        requestWorkOrderCl(this.workOrderDetail.id)
                            .then((res) => {
                                done();
                                this.$toast({
                                    type: "success",
                                    message: "处理成功!",
                                    forbidClick: true,
                                    onClose: () => {
                                        this.getDetail();
                                    },
                                });
                            })
                            .catch((err) => {
                                done(false);
                            });
                    } else {
                        done();
                    }
                },
            });
        },
        //完成
        workOrderFinish() {
            this.finishShow = true;
        },
        //获取七牛token
        getQiniuToken() {
            requestQiniuToken()
                .then((res) => {
                    this.qiniuData.token = res.data;
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        //图片上传前校验，压缩
        beforeRead(file) {
            const isJPG = file.type === "image/jpeg";
            const isPNG = file.type === "image/png";
            const isLt2M = file.size / 1024 / 1024 < 2;
            const isLt8M = file.size / 1024 / 1024 < 8;
            const isLt10M = file.size / 1024 / 1024 < 10;
            if (!isJPG && !isPNG) {
                this.$toast.fail("图片只能是 JPG/PNG 格式！");
                return false;
            }
            if (!isLt10M) {
                this.$toast.fail("图片大小不能超过 10MB!");
                return false;
            }
            this.qiniuData.key = Date.now() + file.name;
            return new Promise((resolve, reject) => {
                compressAccurately(file, 400).then((fileMin) => {
                    let data = new FormData();
                    data.append("token", this.qiniuData.token);
                    data.append("key", this.qiniuData.key);
                    data.append("file", fileMin);
                    request({
                        url: this.$store.state.qiniuUpload,
                        method: "post",
                        processData: false,
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                        data: data,
                    })
                        .then((res) => {
                            let newFile = fileMin;
                            newFile.key = res.key;
                            resolve(newFile);
                        })
                        .catch((err) => {
                            console.log(err);
                            reject(err);
                        });
                });
            });
        },
        finishSubmit(action, done) {
            if (action === "confirm") {
                this.$refs.finishForm
                    .validate()
                    .then((valid) => {
                        this.finishQuery.workOrderId = this.workOrderDetail.id;
                        this.finishQuery.preImageList = [];
                        this.preImageList.forEach((d) => {
                            this.finishQuery.preImageList.push(d.url);
                        });
                        this.finishQuery.imageList = [];
                        this.imageList.forEach((d) => {
                            this.finishQuery.imageList.push(d.url);
                        });
                        requestWorkOrderFinish(this.finishQuery)
                            .then((res) => {
                                this.$toast.success({
                                    message: "完成成功！",
                                    forbidClick: true,
                                    onClose: () => {
                                        this.getDetail();
                                        done();
                                    },
                                });
                            })
                            .catch((err) => {
                                done(false);
                            });
                    })
                    .catch((err) => {
                        done(false);
                    });
            } else {
                done();
            }
        },
        //添加备注
        workOrderRemark() {
            this.remarkShow = true;
        },
        remarkSubmit(action, done) {
            if (action === "confirm") {
                this.$refs.remarkForm
                    .validate()
                    .then((valid) => {
                        this.remarkQuery.id = this.workOrderDetail.id;
                        requestWorkOrderRemark(this.remarkQuery)
                            .then((res) => {
                                this.$toast.success({
                                    message: "添加成功！",
                                    forbidClick: true,
                                    onClose: () => {
                                        this.getDetail();
                                        done();
                                    },
                                });
                            })
                            .catch((err) => {
                                done();
                            });
                    })
                    .catch((err) => {
                        done(false);
                    });
            } else {
                done();
            }
        },
        confirm() {
            if (!this.customerQuery.length) {
                this.$toast("先请选择人员");
                return;
            }
            const toast1 = this.$toast.loading({
                forbidClick: true,
                duration: 0,
                message: "加载中...",
            });
            switch (this.type) {
                case "xzr":
                    let xzrQuery = {
                        cooperationList: [],
                        workOrderId: this.$route.query.id,
                    };
                    this.customerQuery.forEach((d) => {
                        xzrQuery.cooperationList.push({
                            cooperation: d.name,
                            cooperationId: d.id,
                        });
                    });
                    requestWorkOrderCooperation(xzrQuery)
                        .then((res) => {
                            toast1.clear();
                            this.$toast.success({
                                message: "添加成功！",
                                forbidClick: true,
                                onClose: () => {
                                    this.showCustomer = false;
                                    this.getDetail();
                                },
                            });
                        })
                        .catch((err) => {
                            toast1.clear();
                        });
                    break;
                case "zd":
                    this.zdShow = true;

                default:
                    toast1.clear();
                    break;
            }
        },
        //获取钉钉授权
        getDDconfig() {
            requestDDConfig({
                url: this.$global.url,
            })
                .then((res) => {
                    dd.config({
                        agentId: res.data["agentId"],
                        corpId: res.data["corpId"],
                        timeStamp: res.data["timeStamp"],
                        nonceStr: res.data["nonceStr"],
                        signature: res.data["signature"],
                        jsApiList: [
                            //需要调用的接口列表
                            "biz.telephone.showCallMenu",
                            "biz.map.view",
                        ],
                    });
                })
                .catch((err) => {});
        },

        //拨打电话
        call() {
            if (this.workOrderDetail.basicWorkOrderInfo.customerPhone) {
                let _this = this;
                dd.ready(function () {
                    dd.biz.telephone.showCallMenu({
                        phoneNumber:
                            _this.workOrderDetail.basicWorkOrderInfo
                                .customerPhone, // 期望拨打的电话号码
                        code: "+86", // 国家代号，中国是+86
                        showDingCall: false, // 是否显示钉钉电话
                        onSuccess: function (res) {},
                        onFail: function (err) {
                            alert(JSON.stringify(err));
                        },
                    });
                });
                dd.error(function (err) {
                    // console.log(err);
                    alert("dd error: " + JSON.stringify(err));
                });
            }
        },
        //导航
        goTo() {
            let _this = this;
            dd.ready(function () {
                dd.biz.map.view({
                    latitude: _this.workOrderDetail.basicWorkOrderInfo.lat, // 纬度
                    longitude: _this.workOrderDetail.basicWorkOrderInfo.lng, // 经度
                    title:
                        _this.workOrderDetail.basicWorkOrderInfo.communityName, // 地址/POI名称
                });
            });
            dd.error(function (err) {
                // console.log(err);
                this.$dialog.alert({
                    message: "dd error: " + JSON.stringify(err),
                });
            });
        },
        //正数或0，最多保留两位小数
        validNum0Decimal2(val) {
            if (!val) {
                return true;
            }
            return validNum0Decimal2(val);
        },
    },
    watch: {
        showCustomer(newData, oldData) {
            if (!newData) {
                this.type = ""; //区分当前操作（转单派单等）
                this.searchValueCustomer = "";
                this.searchLoad = false;
                this.customerQuery = [];
                this.customerSearchList = [];
                this.onSearchCustomer();
            }
        },
        finishShow(newData, oldData) {
            if (!newData) {
                this.finishQuery = {
                    workOrderId: "",
                    content: "",
                    fee: "",
                    preImageList: [],
                    imageList: [],
                };
                this.preImageList = [];
                this.imageList = [];
            }
        },
        remarkShow(newData, oldData) {
            if (!newData) {
                this.remarkQuery = {
                    id: "",
                    remark: "",
                };
            }
        },
    },
};
</script>
<style lang="scss" scoped>
@import "../common/scss/variable.scss";
.noData {
    line-height: 1rem;
}
.theme-color {
    color: $theme-color;
}
.tabs {
    .title {
        text-align: left;
        // padding: 0.3rem 0.2rem;
        // font-weight: 600;
        font-size: 0.32rem;
        color: #323233;
        &::after {
            border: none;
        }
    }
    /deep/.van-tab {
        flex: 1;
    }
    /deep/.van-tabs__content {
        height: calc(100vh - 1.2rem);
        overflow: scroll;
        background: #fff;
    }
    .imgBody {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        background-color: #fff;
        padding: 0 0.2rem 0.5rem;
        border-radius: 0.2rem;
        .imgCard {
            margin: 0 0.1rem;
            .text {
                line-height: 0.8rem;
            }
        }
        position: relative;
        &::after {
            position: absolute;
            box-sizing: border-box;
            content: " ";
            pointer-events: none;
            right: 0.42667rem;
            bottom: 0;
            left: 0.42667rem;
            border-bottom: 0.02667rem solid #ebedf0;
            -webkit-transform: scaleY(0.5);
            transform: scaleY(0.5);
        }
    }
    .imgBody1 {
        padding: 0 0.2rem;
    }
}
/deep/.van-cell__title {
    flex: 1;
}
.btn {
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 99;
    border-radius: 0.1rem;
    overflow: hidden;
    display: flex;
    /deep/.van-button {
        margin-left: -1px;
        border: none;
        border-radius: 0;
        flex: 1;
        padding: 0%;
        &:not(:last-child)::after {
            height: 50%;
            position: absolute;
            box-sizing: border-box;
            content: " ";
            pointer-events: none;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            border-right: 0.02667rem solid #ebedf0;
            z-index: 99;
        }
    }
}
.search {
    position: relative;
    height: 100%;
    .searchInput {
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 99;
    }
    .searchValue {
        height: 100%;
        overflow: auto;
    }
    .searchBtn {
        width: 100%;
        position: absolute;
        bottom: 0;
        left: 0;
        z-index: 99;
        overflow: hidden;
        display: flex;
        border-top: 0.5px solid #eaeaea;
        /deep/.van-button {
            border: none;
            border-radius: 0;
            flex: 1;
            padding: 0%;
        }
    }
}
.field {
    padding: 0.26667rem 0.42667rem;
    background: #fff;
    font-size: 0.3rem;
    line-height: 0.64rem;
    color: #323232;
    text-align: left;
    position: relative;
    ::after {
        position: absolute;
        box-sizing: border-box;
        content: " ";
        pointer-events: none;
        right: 0.42667rem;
        bottom: 0;
        left: 0.42667rem;
        border-bottom: 0.02667rem solid #ebedf0;
        -webkit-transform: scaleY(0.5);
        transform: scaleY(0.5);
    }
}
.body {
    padding: 0.1rem;
    text-align: left;
    .van-uploader {
        // margin: 0.2rem;
        /deep/.van-uploader__preview-image {
            border: 1px solid #ebedf0;
        }
    }
    .picCard {
        display: inline-block;
        margin: 0.2rem;
        width: 2.2rem;
        .text {
            text-align: center;
            .van-field {
                padding: 0;
                /deep/input {
                    text-align: center;
                }
            }
        }
        .textBorder {
            /deep/.van-field__body {
                border: 1px solid $border-color;
                border-radius: 0.1rem;
                overflow: hidden;
            }
        }
    }
}
.van-steps {
    text-align: left;
    padding-left: 2rem;
    /deep/.van-step__title {
        padding-left: 0.3rem;
        p {
            padding-top: 0.2rem;
        }
    }
}
.border::after,
.border1::after {
    position: absolute;
    box-sizing: border-box;
    content: " ";
    pointer-events: none;
    right: 0;
    bottom: 0;
    left: 0;
    border-bottom: 0.02667rem solid #ebedf0;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
}
.border1::after {
    border-bottom: 0.02667rem solid #c7c7c7;
}
.van-collapse {
    /deep/.van-cell__title {
        flex: 1;
    }
}
.van-search {
    /deep/i {
        line-height: 0.84rem;
    }
    /deep/input {
        border: none;
    }
}
.van-collapse-item__content {
    padding-top: 0;
}
.dialogForm {
    max-height: 12rem;
    overflow: auto;
}
.errorLeft {
    /deep/.van-field__error-message {
        text-align: left;
        padding-left: 0.2rem;
    }
    /deep/.van-field {
        padding: 0;

        .van-field__body {
            display: none;
        }
    }
}
</style>
